import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import connectorService from '../services/connectorService';
import './VaultSourceList.css';

const AdminConnectorsList = () => {
  const [connectors, setConnectors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');

  const navigate = useNavigate();

  useEffect(() => {
    loadConnectors();
  }, []);

  const loadConnectors = async () => {
    try {
      setLoading(true);
      setError(null);

      const filterParams = {};
      if (searchTerm) filterParams.search = searchTerm;

      const response = await connectorService.getAllConnectors(filterParams);
      setConnectors(response.connectors || []);
    } catch (err) {
      console.error('Error loading connectors:', err);
      setError(err.response?.data?.message || err.message || 'Failed to load connectors');
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = () => {
    loadConnectors();
  };

  const handleSearchKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this connector?')) {
      return;
    }

    try {
      await connectorService.deleteConnector(id);
      setConnectors(connectors.filter(c => c.id !== id));
    } catch (err) {
      console.error('Error deleting connector:', err);
      alert(err.response?.data?.message || 'Failed to delete connector');
    }
  };

  if (loading) {
    return <div className="loading">Loading connectors...</div>;
  }

  return (
    <div className="vaultsource-list-container">
      <div className="header">
        <h1>Connectors</h1>
        <button
          className="btn btn-primary"
          onClick={() => navigate('/connectors/new')}
        >
          Add Connector
        </button>
      </div>

      {error && <div className="error-message">{error}</div>}

      <div className="search-bar">
        <input
          type="text"
          placeholder="Search by ID or name..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          onKeyPress={handleSearchKeyPress}
        />
        <button className="btn btn-search" onClick={handleSearch}>
          Search
        </button>
        <button className="btn btn-secondary" onClick={() => { setSearchTerm(''); loadConnectors(); }}>
          Clear
        </button>
      </div>

      <div className="table-container">
        <table className="vaultsource-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Name</th>
              <th>Type</th>
              <th>Environment</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {connectors.length === 0 ? (
              <tr>
                <td colSpan="6" className="no-data">No connectors found</td>
              </tr>
            ) : (
              connectors.map((connector) => (
                <tr
                  key={connector.id}
                  onClick={() => navigate(`/connectors/${connector.id}`)}
                  className="clickable-row"
                  title="Click to view"
                >
                  <td>{connector.id}</td>
                  <td>{connector.connectorName}</td>
                  <td>{connector.connectorType}</td>
                  <td>{connector.environment}</td>
                  <td>
                    <span className={`status-badge status-${(connector.connectorStatus || '').toLowerCase()}`}>
                      {connector.connectorStatus}
                    </span>
                  </td>
                  <td className="actions">
                    <button
                      className="btn btn-edit"
                      onClick={(e) => {
                        e.stopPropagation();
                        navigate(`/connectors/${connector.id}/edit`);
                      }}
                      title="Edit"
                    >
                      ✏️
                    </button>
                    <button
                      className="btn btn-delete"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleDelete(connector.id);
                      }}
                      title="Delete"
                    >
                      🗑️
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AdminConnectorsList;
